import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { Component, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { EntityListAction, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { ConfigurationService, GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HrmPayCurentYearMonthComponent } from "../../hrm-pay-curent-year-month/hrm-pay-curent-year-month.component";
import { HrmReportPrintKind } from "../../models/enums/round-kind";
import { HRNotificationHeader } from "../../models/hrnotification-header.model";

@Component({
  selector: "ngx-hrm-insurance-disk",
  templateUrl: "./hrm-insurance-disk.component.html",
  styleUrls: ["./hrm-insurance-disk.component.scss"],
})
export class HrmInsuranceDskComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  actions: EntityListAction[];
  PayCompaniesIds: number[] = [];
  model: any;
  filterInfo: NameValue[] = [];
  pcColumns: form_control[] = [];
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(
    private splashFormService: SplashFormService,
    private httpClient: HttpClient,
    private configurations: ConfigurationService,
    private lookupservice: LookupService
  ) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "MonthlySalaryCalculationInformation/HRNotificationsHeader";
    this.areaName = "Payroll";
    this.label = "ساخت دیسکت بیمه";
    this.setColumns();
    this.setactions();
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      if (
        this.accountService.authService.getHrmPayCurentYearMonth().CurentYear &&
        this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth
      ) {
        this.filterInfo.push({ Name: "IssueYear", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear, Operator: "eq" });
        this.filterInfo.push({ Name: "IssueMonth", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth, Operator: "eq" });
      }
    } else this.setHrmPayCurentYearMonth();
  }
  setColumns() {
    let group: any = {};
    this.model = {};
    this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    this.pcColumns = [];
    this.pcColumns.push(<form_control>{
      label: "کد شعبه",
      controlType: FormControlTypes.dropdown,
      modelName: "PartyCode",
      disabled: false,
      name: "PartyCode",
      order: 0,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 1,
      userClass: "select-shr",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.pcColumns.push(<form_control>{
      label: "عنوان شعبه",
      controlType: FormControlTypes.dropdown,
      modelName: "DisplayName",
      disabled: false,
      name: "DisplayName",
      order: 1,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 2,
      userClass: "select-shr",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.pcColumns.push(<form_control>{
      label: "کد کارگاه",
      controlType: FormControlTypes.dropdown,
      modelName: "WorkshopCode",
      disabled: false,
      name: "WorkshopCode",
      order: 1,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 3,
      userClass: "select-shr",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.pcColumns.push(<form_control>{
      label: "نام کارگاه",
      controlType: FormControlTypes.dropdown,
      modelName: "CompanyName",
      disabled: false,
      name: "CompanyName",
      order: 1,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 3,
      userClass: "select-shr",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });

    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueYear",
      disabled: false,
      name: "IssueYear",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 1,
      userClass: "select-sm",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.columns.push(<form_control>{
      label: "ماه",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueMonth",
      disabled: false,
      name: "IssueMonth",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 2,
      userClass: "select-sm",
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });

    group["IssueYear"] = new UntypedFormControl(this.model.IssueYear, Validators.required);
    group["IssueMonth"] = new UntypedFormControl(this.model.IssueMonth, Validators.required);
    this.lookupservice
      .getLookupbyCode("HRM", "HrmReportPrintKind", HrmReportPrintKind.BillPayAll)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((rk) => {
        group["HrmReportPrintKind"] = new UntypedFormControl(rk.Code, Validators.required);
      });
    group["PayCompaniesIds"] = new UntypedFormControl(undefined);
    this.group = new UntypedFormGroup(group);
    this.model = this.getDataFromFormGroup(this.model);
  }
  saveText(text, filename) {
    var a = document.createElement("a");
    a.setAttribute("href", "data:text/plain;charset=utf-u," + encodeURIComponent(text));
    a.setAttribute("download", filename);
    a.click();
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: HRNotificationHeader,
    onRowsSelected: HRNotificationHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    var filters: GridFilter[] = [];
    if (isAllSelected) {
      filters.push({ Filed: "IsAllSelected", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: isAllSelected, Logic: "and" });
    } else if (onRowsSelected && onRowsSelected.length > 0) {
      let PersonnelIds: number[] = [];
      onRowsSelected.forEach((x) => {
        PersonnelIds.push(x.HrmPersonnelId);
      });
      filters.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: PersonnelIds, Logic: "and" });
    } else if (onRowSelected) {
      let PersonnelIds: number[] = [];
      PersonnelIds.push(onRowSelected.HrmPersonnelId);
      filters.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: PersonnelIds, Logic: "and" });
    }

    ///  در اینجا باید سال و ماه محاسبه دریافت شود

    let IssueYear = this.group.controls["IssueYear"].value;
    let IssueMonth = this.group.controls["IssueMonth"].value;
    let IssueYearMonth = IssueYear * 12 + IssueMonth;
    filters.push({ Filed: "IssueYearMonth", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueYearMonth, Logic: "and" });
    filters.push({ Filed: "IssueYear", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueYear, Logic: "and" });
    filters.push({ Filed: "IssueMonth", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueMonth, Logic: "and" });
    filters.push({
      Filed: "HrmReportPrintKind",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: HrmReportPrintKind.BillPayWithOuteBackPay,
      Logic: "and",
    });
    if ((this.PayCompaniesIds && this.PayCompaniesIds.length > 0) || this.group?.get("PayCompaniesIds")?.value) {
      if (!this.PayCompaniesIds || this.PayCompaniesIds.length <= 0) {
        this.PayCompaniesIds = [];
        this.PayCompaniesIds.push(this.group?.get("PayCompaniesIds")?.value);
      }
      filters.push({ Filed: "PayCompaniesIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.PayCompaniesIds, Logic: "and" });
    } else {
      this.sts.showDialog("اول شعبه بيمه مورد نظر را انتخاب كنيد.", "خطا");
      return;
    }

    let FileName: string = "";

    if (!filters || filters.length <= 0) {
      this.sts.showDialog("هیچ کارمندی انتخاب نشده است.", "");
    }
    this.splashFormService.openDialog("", "در حال ساخت دیسکت بیمه");
    this.httpCommonService
      .create(action.apiName, filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this.saveText(JSON.stringify(x.DSKKARProps), "DSKKARProps.json");
          this.saveText(JSON.stringify(x.DSKWORProps), "DSKWORProps.json");
          this.sts.showDialog("دیسکت با موفقیت تهیه شد.", "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(` خطا در ساخت دیسکت بیمه${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  setHrmPayCurentYearMonth() {
    this.dialogService
      .open(
        HrmPayCurentYearMonthComponent,
        {
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        this.ngOnInit();
      });
  }
  onRowsSelected($event) {
    if ($event) {
      $event.forEach((x) => {
        this.PayCompaniesIds.push(x.PayCompaniesId);
      });
    }
  }
  setactions() {
    this.actions = [
      {
        name: "Preview",
        disabled: false,
        displayName: "ساخت دیسکت",
        iconName: "icon-floppy-o",
        apiName: "MonthlySalaryCalculationInformation/MakeInsDisk",
        areaName: "Payroll",
        permission: Permission.viewPermission,
      },
    ];
  }
  downloadFile(file: string): Observable<HttpEvent<Blob>> {
    let apiDownloadUrl = `${this.configurations.baseUrl}/api/MonthlySalaryCalculationInformation/Download`;
    return this.httpClient.request(
      new HttpRequest("GET", `${apiDownloadUrl}?file=${file}`, null, {
        reportProgress: true,
        responseType: "blob",
      })
    );
  }
}
